/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Radio } from "antd";
const RadioGroup = Radio.Group;

class InputRadiolayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      select2options: [],
      value: null,
    };
  }
  // componentDidMount() {
  //   console.log(this.props.selectdata);
  //   console.log(this.props.Queuedata);
  // }

  handleChange(value) {
    console.log(`selected ${value}`);
  }

  onChange(event) {
  
    this.props.selectdata.map((data, key) => {
      if (data.name === event.target.value) {
        this.props.onselectChanges({
          id: data.name,
          value: event.target.value,
          parrentMode: data.parrentMode,
          parrentName: data.parrentName,
        });
      }
      // else {
      //     this
      //         .props
      //         .onselectChanges({id: data.name, value: null, parrentMode: data.parrentMode, parrentName: data.parrentName});
      // }
    });
  }

  render() {
    let { parrent_value } = this.props;
    return (
      <RadioGroup
        value={parrent_value ? parrent_value : null}
        onChange={this.onChange.bind(this)}
      >
        {this.props.selectdata.map((data, key) => {
          if (data.readonly) {
            return (
              <div class="ant-radio-group ant-radio-group-outline">
                <label class="ant-radio-wrapper">
                  <span
                    class={`ant-radio ${data.value ? "ant-radio-checked" : ""}`}
                  >
                    <span class="ant-radio-inner"></span>
                  </span>
                  <span>{data.label}</span>
                </label>
              </div>
            );
          } else {
            return (
              <Radio key={key} value={data.name}>
                {data.label}
              </Radio>
            );
          }
        })}
      </RadioGroup>
    );
  }
}

export default InputRadiolayer;
